// utils/languageConfig.js
export const NO_DROPDOWN_CODES = ['en', 'ar', 'us', 'au', 'eg', 'jo'];

const ENGLISH_GROUP = ['en', 'us', 'au'];
const ARABIC_GROUP = ['ar', 'eg', 'jo'];

// Strip any culture-code suffix and normalize, e.g. 'en-AU' -> 'au' is NOT
// derivable safely, so instead we match on the raw code AND fall back to
// checking if it starts with/contains a known no-dropdown code.
export const isNoDropdownCode = (code) => {
  const normalized = code?.toLowerCase()?.trim();
  if (!normalized) return false;
  return NO_DROPDOWN_CODES.some(
    (c) => normalized === c || normalized.startsWith(`${c}-`) || normalized.endsWith(`-${c}`)
  );
};

export const getBaseLanguage = (code) => {
  const normalized = code?.toLowerCase()?.trim();
  if (!normalized) return normalized;
  if (ENGLISH_GROUP.some((c) => normalized === c || normalized.startsWith(`${c}-`) || normalized.endsWith(`-${c}`))) return 'en';
  if (ARABIC_GROUP.some((c) => normalized === c || normalized.startsWith(`${c}-`) || normalized.endsWith(`-${c}`))) return 'ar';
  return normalized;
};

export const getOppositeBaseLanguage = (code) =>
  getBaseLanguage(code) === 'en' ? 'ar' : 'en';
